<template>
    <BaseWidget :title="widget.title" :title-url="widget.titleUrl" :footer="widget.footer">
        <EmptyState picture v-if="widget.content.first.length === 0">
            <template v-slot:picture>
                <img src="/img/utils/undraw_blank_canvas_empty_state_positive.svg" alt="empty state" class="h-40" />
            </template>
        </EmptyState>
        <ul v-for="student in widget.content.first" class="text-sm" v-else :key="student.id">
            <li>
                <a :href="student.link">{{ student.full_name }}</a>
                <a :href="student.foul_summary_link" class="text-indigo-500">({{ student.fouls_count }})</a>
            </li>
        </ul>

        <button type="button" @click="show = true" v-if="widget.content.diff > 0">
            <span class="text-xs text-indigo-600">
                {{
                    $tc('messages.and_X_more', widget.content.diff, {
                        x: widget.content.diff,
                    })
                }}
            </span>

            <SlideOver :show="show" @close="show = false">
                <ul v-for="student in widget.content.first" class="text-sm" :key="student.id">
                    <li>
                        <a :href="student.link">{{ student.full_name }}</a>
                        <a :href="student.foul_summary_link" class="text-indigo-500">({{ student.fouls_count }})</a>
                    </li>
                </ul>
                <ul v-for="student in widget.content.rest" class="text-sm" :key="student.id">
                    <li>
                        <a :href="student.link">{{ student.full_name }}</a>
                        <a :href="student.foul_summary_link" class="text-indigo-500">({{ student.fouls_count }})</a>
                    </li>
                </ul>
            </SlideOver>
        </button>
    </BaseWidget>
</template>

<script>
import BaseWidget from '@/components/Widgets/BaseWidget.vue';
import EmptyState from '@/components/EmptyState.vue';
import SlideOver from '@/components/SlideOver.vue';

export default {
    name: 'GroupFoulsWidget',
    components: {
        BaseWidget,
        EmptyState,
        SlideOver,
    },
    props: {
        widget: {
            required: true,
            type: Object,
        },
    },
    data() {
        return {
            show: false,
        };
    },
};
</script>
